<template>
    <div
        class="card-challenge-request-item"
        :class="rankingClass">
        <div class="card-challenge-request-item__outer">
            <div class="card-challenge-request-item__inner">
                <img
                    :src="userImageLink"
                    class="card-challenge-request-item__user-img">
                <span class="card-challenge-request-item__username">{{ requestItem.user1.username }}</span>
                <span class="card-challenge-request-item__label">İSTEK</span>
                <span class="card-challenge-request-item__rank">{{ rankText }}</span>
                <div class="wr-card-challenge-request-item__buttons">
                    <button
                        class="btn-card-challenge-request-item-accept"
                        @click="$emit('acceptChallenge', requestItem)">
                        <span class="btn-card-challenge-request-item-accept__icon"></span>
                    </button>
                    <button
                        class="btn-card-challenge-request-item-reject"
                        @click="$emit('rejectChallenge', requestItem)">
                        <span class="btn-card-challenge-request-item-reject__icon"></span>
                    </button>
                </div>
            </div>
        </div>
        <div class="card-challenge-request-item__stat-win">
            <span class="card-challenge-request-item__stat-win-text">{{ requestItem.user1.stats.win }}</span>
            <span class="card-challenge-request-item__stat-win-icon"></span>
        </div>
        <div class="card-challenge-request-item__stat-loss">
            <span class="card-challenge-request-item__stat-loss-icon"></span>
            <span class="card-challenge-request-item__stat-loss-text">{{ requestItem.user1.stats.loss }}</span>
        </div>

        <div
            v-if="showRankingGem"
            class="card-challenge-request-item__ranking-gem">
            <span class="card-challenge-request-item__ranking-gem-icon"></span>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            requestItem: {
                type: Object,
                default: {
                    id: 5,
                    timestamp: 1761395197,
                    user1: {
                        id: 2,
                        username: "testuser101214",
                        status: "WAIT-PRACTICE",
                        rank: 217,
                        stats: {
                            win: 19,
                            loss: 4
                        }
                    }
                },
            },
        },

        computed: {
            showRankingGem(){
                return this.requestItem.user1.rank < 11 ? true : false;
            },

            userImageLink(){
                return this.$store.state.api.getImage + this.requestItem.user1.id;
            },

            rankingClass(){
                let rank = this.requestItem.user1.rank;
                if(rank <= 3){
                    return 'card-challenge-request-item__rank-' + rank;
                }
                else if(rank <= 10){
                    return 'card-challenge-request-item__rank-10';
                }
                return '';
            },

            rankText(){
                let rank = this.requestItem.user1.rank;
                if(rank === 1){
                    return 'BİRİNCİ';
                }
                else if(rank === 2){
                    return 'İKİNCİ';
                }
                else if(rank === 3){
                    return 'ÜÇÜNCÜ';
                }
                else if(rank <= 10){
                    return 'İLK 10';
                }
                return `Sıra #${rank}`;
            },
        }
    };
</script>

<style scoped src="@/css/components/card-challenge-request-item.css"></style>